import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Logger } from '@saviynt/common';

import { useLazyGetActionStatusQuery } from '../../../shared/store/globalApis';
import { globalActions } from '../../../shared/store/globalSlice';

const useGetActionStatus = () => {
  const dispatch = useDispatch();

  const [fetchActionStatus] = useLazyGetActionStatusQuery();

  const initializeActionStatus = useCallback(async () => {
    const payload = {
      workflow: 'violation-workbench',
    };

    try {
      const controller = fetchActionStatus(payload);
      const response = await controller.unwrap();

      const typedResponse = response as {
        readOnly: boolean;
      };

      dispatch(globalActions.setIsReadOnlyAction(typedResponse.readOnly));

      return true;
    } catch {
      Logger.log('Error fetching action status');

      return true;
    }
  }, [dispatch, fetchActionStatus]);

  return { initializeActionStatus };
};

// eslint-disable-next-line import/prefer-default-export
export { useGetActionStatus };
